import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@petsmart-ui/sparky';
import { usePageLayout, useStore } from '@libs/common-next';
import './StoreTooltip.scss';
type StoreTooltipProps = {
  isFormField?: boolean;
};
export default function StoreTooltip(t0) {
  const $ = _c(2);
  const {
    isFormField
  } = t0;
  const {
    contactUsFormStore
  } = usePageLayout();
  const {
    selectedStore
  } = useStore();
  const store = isFormField ? contactUsFormStore : selectedStore?.data;
  let t1;
  if ($[0] !== store) {
    t1 = <div className="store-tooltip__address">{store ? <Tooltip hideIcon={true} enableHover={true} buttonVariant="link" buttonText={store.Name} data-testid="tooltip-address">{store.StreetLine1}<br />{store.City}, {store.StateProvinceAbbreviation} {store.ZipPostalCode}</Tooltip> : <div>Please select a store</div>}</div>;
    $[0] = store;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}